import { BasePortfolio } from '@ddt-web/domain';

import { SharedEngagementsConstants } from '../../constants/shared-engagements.constants';
import { BpasEngagement } from '../bpas-engagement.model';
import { EngagementPortfolioRequest } from '../requests';
import { EngagementRequest } from '../requests/engagement-request.model';

export const mapBpasEngagementsToUpdateEngagementRequest = (bpasEngagements: BpasEngagement[], action: string) => {
	return bpasEngagements.map(bpasEngagement => {
		return {
			children: bpasEngagement.children ? bpasEngagement.children.map(mapBpasBasePortfolioToEngagementPortfolioRequest) : [],
			description: bpasEngagement.description,
			uniqueId: action === SharedEngagementsConstants.UPDATE_MODE.EDIT ? bpasEngagement.uniqueId : null,
			benchmarkDetails: bpasEngagement.benchmarkDetails,
			flags: bpasEngagement.flags,
			origin: bpasEngagement.origin,
			type: bpasEngagement.type,
			applications: bpasEngagement.applications,
			currency: bpasEngagement.currency,
			lastModifiedDisplayDate: bpasEngagement.lastModifiedDisplayDate
		} as EngagementRequest;
	});
};

export const mapBpasBasePortfolioToEngagementPortfolioRequest = (portfolio: BasePortfolio) => {
	return {
		children: portfolio.children,
		description: portfolio.description,
		uniqueId: portfolio.uniqueId,
		flags: portfolio.flags,
		subType: portfolio.subType,
		type: portfolio.type,
		portOrder: portfolio.portOrder,
		applications: portfolio.applications,
		lastModifiedDisplayDate: portfolio.lastModifiedDisplayDate
	} as EngagementPortfolioRequest;
};
